import { render, staticRenderFns } from "./DCheckboxEditor.vue?vue&type=template&id=c7346780&"
import script from "./DCheckboxEditor.vue?vue&type=script&lang=js&"
export * from "./DCheckboxEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports